export class DocumentTemplate{
    id:number=0;
    name:string="";
    conditions:any;
    details:any;
    referenceprefix:string="";
    description:string="";
    description2:string="";
    typedocument:number=0;
    id_type:number=0;
    id_documentsrule:number=0;
    table:string="";
    documentsrule:any;
    enable_cashflow:boolean=false;
    enable_inventory:boolean=false;
    mode_details:number=0;
}